import { useMutation } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { WhatsAppConversation } from "../../aiConversations.types";
import { requestSetConversationMode } from "./setConversationMode.request";
import { SetConversationModeRequestBody } from "./setConversationMode.types";

const useSetConversationMode = (
  options?: MutationOptions<
    WhatsAppConversation,
    ApiServiceError<ApiError>,
    SetConversationModeRequestBody
  >
) => {
  return useMutation({
    mutationFn: requestSetConversationMode,
    onError: toastServerError,
    ...options
  });
};

export default useSetConversationMode;
